/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Moderate_Members_HintInputs */



/**
* | output |
* | --- |
* | "When you put a user in time-out they will not be able to send messages in chat, reply within threads, react to messages or speak in voice or stage channels." |
*
* @param {Leveling_Perm_Moderate_Members_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_moderate_members_hint = /** @type {((inputs?: Leveling_Perm_Moderate_Members_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Moderate_Members_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Участник в тайм-ауте не может писать в чат, отвечать в ветках, ставить реакции и говорить в голосовых каналах и на трибунах.")
	return /** @type {LocalizedString} */ ("When you put a user in time-out they will not be able to send messages in chat, reply within threads, react to messages or speak in voice or stage channels.")
});